<script setup lang="ts">
import { computed } from "vue";
import { type DRPartialProject, type Project, ProjectStatus } from "@/types";
import ProjectStatusBadge from "./ProjectStatusBadge.vue";
import { useUpdateProject } from "@/stores/queries";

const props = withDefaults(
  defineProps<{
    project: DRPartialProject | Project;
    disabled?: boolean;
    minimal?: boolean;
  }>(),
  {
    disabled: false,
    minimal: false,
  }
);

const { mutateAsync: mutateUpdateProject } = useUpdateProject();

const status = computed(() => props.project.status);

const handleChangeStatus = (value: ProjectStatus) => {
  mutateUpdateProject({
    id: props.project.id,
    status: value,
  });
};

const statusList = [
  ProjectStatus.READY,
  ProjectStatus.IN_PROGRESS,
  ProjectStatus.FINISHED,
];
</script>

<template>
  <div @click.stop>
    <el-dropdown trigger="click" :disabled="disabled">
      <div>
        <ProjectStatusBadge
          :status="status"
          :clickable="!disabled"
          :disabled="disabled"
          :minimal="minimal"
        />
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <div class="px-3 py-2 fw-medium" style="width: 10rem">
            {{ $t("dashboard:projects.actions.edit-status-popup.title") }}
          </div>
          <el-dropdown-item
            v-for="s in statusList"
            :key="s"
            @click="handleChangeStatus(s)"
            ><div>
              <ProjectStatusBadge :status="s" :minimal="minimal" /></div
          ></el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<style lang="scss" scoped></style>
